import React from 'react';
import {CollapsibleComponent, CollapsibleHead, CollapsibleContent} from 'react-collapsible-component';
import {Collapse} from 'react-collapse';


class HNotes extends React.Component {

  static getPoolNote() {
    return (<Collapse isOpened={true}>
        <ul>
          <li>Current Sign % - sign percentage for validator in current epoch.</li>
          <li>Short Term Sign % - sign percent for validator in last 8 epochs.</li>
          <li>Daily sign % - sign percentage for validator for all epochs in last 24 epochs.</li>
          <li>Mid term sign % - sign percent for validator in last 240 epochs.</li>
          <li>Long term sign % - sign percent for validator in last 720 epochs</li>
          <li>Click anywhere on a record to see details.</li>
        </ul>
      </Collapse>);
  }

  static getFilterHelp() {
    return (<div>
      <hr/>
      <Collapse isOpened={true}>
        <div><p><b>My Account Search Help</b></p>
          <ul>
            <li>Input - $ONE Address - enter your $ONE address.</li>
            <li>Input - Nickname/Alias - an easy to remember nick name or alias. Save once and search across devices in future. A shortcut is also placed automatically on this page for nicknames/aliases used on current device. Please do not use your or other people's names.</li>
            <li>Input - Search - save the alias (if entered) in browser and perform the search. If address is not entered and alias is not known to the backend, search will not work.</li>
            <li>Input - Save & Search - save the search criteria with the entered nickname for future use and perform the search.</li>
            <li>Remove Aliases link - remove all aliases from this device and Smart Stake backend.</li>
            <li>Summary - Total Stake - Total $ONE staked.</li>
            <li>Summary - Total Reward - Total outstanding $ONE reward across all validators.</li>
            <li>Search Results - Address - Address for which rewards are being searched.</li>
            <li>Search Results - Validator Name - Staking validator for the current record.</li>
            <li>Search Results - Validator Total Stake - Total $ONE staked with the validator by all delegates.</li>
            <li>Search Results - Stake in Validator - Total $ONE staked by the address in a given validator.</li>
            <li>Search Results - % Stake (portfolio) - for a given address, this is %age of all $ONE staked with current validator.</li>
            <li>Search Results - Rewards in Validator - Total $ONE reward oustanding for the address in a given validator.</li>
            <li>Search Results - % Rewards (portfolio) - for a given address, this is %age of all $ONE rewards outstanding with current validator.</li>
          </ul>
        </div>
      </Collapse>
    </div>);
  }


}
export default HNotes;



// WEBPACK FOOTER //
// ./src/oasis/OasisNotes.js